import { Form } from '@arco-design/web-react';

import styles from './index.module.less';
import { OPTION_META_PREFIX } from './paths';

const FormItem = Form.Item;

interface OptionMetaRootFieldProps {
  className?: string;
}

/** 仅注册 Form 字段，不参与展示（optionMeta 为对象，避免 Input 绑定） */
function HiddenFormCollector() {
  return null;
}

/** optionMeta 根字段 hidden 收集（optionMeta[提交值] = 完整 option） */
export function OptionMetaRootField({ className }: OptionMetaRootFieldProps) {
  return (
    <FormItem field={OPTION_META_PREFIX} hidden className={className ?? styles.hiddenField} style={{ display: 'none', margin: 0 }}>
      <HiddenFormCollector />
    </FormItem>
  );
}
